import ItemCategoryServices from "@/services/items/items-category";
import ItemServices from "@/services/items";
import ItemPriceTierServices from "@/services/items/items-price-tier";
import ItemUsesServices from "@/services/items/items-uses";
import ItemBundleServices from "@/services/items/items-bundle";
import { find, sortBy, findIndex, uniq } from "lodash";

const state = {
    categories: [],
    dueOptions: [],
    isDueOptionsRendered: false,
    fees: [],
    itemDetails: [],
    isPriceEdited: false,
    isDueChangeToNone: false,
    itemDosage: null,
    priceTiers: [],
    hasRetrievePriceTiers: false, // to check whehter the getPriceTier has been retrieved
    editDirty: false,
    usesCount: 0,
    bundlesCount: 0
};
const getters = {
    itemDetails(state) {
        return state.itemDetails;
    },
    groupedCategories(state) {
        let itemType = [];
        state.categories.forEach(category => {
            if (!find(itemType, { id: "it#" + category.item_type.id })) {
                itemType.push({
                    id: "it#" + category.item_type.id,
                    unselectable: true,
                    name: category.item_type.name
                });
            }
        });
        itemType = sortBy(itemType, "name");
        state.categories.forEach(category => {
            itemType.splice(
                findIndex(itemType, { id: "it#" + category.item_type.id }) + 1,
                0,
                category
            );
        });

        return itemType;
    },
    dueOptions(state) {
        return state.dueOptions
            ? [
                  { value: 0, text: "None", seconds: 0 },
                  ...state.dueOptions.map(option => ({
                      text: option.name,
                      value: option.id,
                      seconds: option.value
                  }))
              ]
            : [{ value: 0, text: "None", seconds: 0 }];
    },
    priceTiers(state) {
        return state.priceTiers;
    },
    isDirty(state) {
        return state.editDirty;
    },
    usesCount(state) {
        return state.usesCount;
    },
    bundlesCount(state) {
        return state.bundlesCount;
    },
    isPriceEdited(state) {
        return state.isPriceEdited;
    },
    isDueChangeToNone(state) {
        return state.isDueChangeToNone;
    },
    isDueOptionsRendered(state) {
        return state.isDueOptionsRendered;
    }
};
const mutations = {
    setItemDetails(state, payload) {
        state.itemDetails = payload;
    },
    setItemDosage(state, payload) {
        state.itemDosage = payload;
    },
    updateCategories(state, payload) {
        state.categories = payload;
    },
    updateDueOptions(state, payload) {
        state.dueOptions = payload;
    },
    updateFees(state, payload) {
        state.fees = payload;
    },
    setPriceTiers(state, payload) {
        state.priceTiers = payload;
        state.hasRetrievePriceTiers = true;
    },
    setDirty(state, payload) {
        state.editDirty = payload;
    },
    setUsesCount(state, payload) {
        state.usesCount = payload;
    },
    setBundlesCount(state, payload) {
        state.bundlesCount = payload;
    },
    setIsPriceEdited(state, payload) {
        state.isPriceEdited = payload;
    },
    setIsDueChangeToNone(state, payload) {
        state.isDueChangeToNone = payload;
    },
    addTemplateIdsItem(state, payload) {
        if (state.itemDetails) {
            state.itemDetails.template_ids = uniq(
                state.itemDetails.template_ids.concat(payload)
            );
        }
    },
    setIsDueOptionsRendered(state, payload) {
        state.isDueOptionsRendered = payload;
    }
};
const actions = {
    async getCategory({ commit }) {
        let categories = await ItemCategoryServices.all();
        commit("updateCategories", categories);
        return categories;
    },
    async getInventoryDueOptions({ commit }) {
        let dueOptions = await ItemServices.getInventoryDueOptions();
        commit("updateDueOptions", dueOptions);
        commit("setIsDueOptionsRendered", true);
        return dueOptions;
    },
    async getFees({ commit }) {
        let fees = await ItemServices.getFees();
        commit("updateFees", fees);
        return fees;
    },
    async getItemDetails({ commit }, itemId) {
        const item = await ItemServices.getItemDetails(itemId, {
            encoded: true,
            with_unit_cost: true
        });
        commit("setItemDetails", item);
        return item;
    },
    async getItemDosage({ commit }, itemId) {
        const dosage = await ItemServices.getItemDosage(itemId);
        commit("setItemDosage", dosage);
        return dosage;
    },
    async getPriceTiers({ commit }, itemId) {
        let priceTiers = await ItemPriceTierServices.getPriceTiers(itemId);
        priceTiers = sortBy(priceTiers, "max_quantity");
        commit("setPriceTiers", priceTiers);
        return priceTiers;
    },
    clearItemDetails({ commit }) {
        commit("setItemDetails", null);
    },
    async getUsesCount({ commit }, itemId) {
        let usesCount = await ItemUsesServices.getUsesCount(itemId);
        commit("setUsesCount", usesCount);
        return usesCount;
    },
    async getBundlesCount({ commit }, itemId) {
        let bundlesCount = await ItemBundleServices.getBundlesCount(itemId);
        commit("setBundlesCount", bundlesCount);
        return bundlesCount;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
